<template>
  <div class="modal is-active"
    role="dialog"
    aria-label="Delete Role"
    aria-hidden="false"
    ref="modal"
    @keydown.tab="trapFocus"
  >
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Delete Role</p>
        <button
          class="icon is-right"
          tabindex="0"
          @click="closeModal"
          ref="closeIcon"
        >
          <font-awesome-icon :icon="['fal', 'times']" title="Close" />
        </button>
      </header>
      <section class="modal-card-body">
        <div class="modal-body">
          You cannot recover deleted role.
          <br>Are you sure you want to delete this role?
        </div>
        <div class="update-box">
          <a tabindex="0" role="button"
            @click="closeModal"
            @keypress.enter="closeModal"
          >
            Cancel
          </a>
          <button
            class="button is-primary"
            @click="deleteRole">
              Delete Role
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
} from '@fortawesome/pro-light-svg-icons';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faTimes,
);

export default {
  mixins: [NotificationManager],
  props: ['locationPermission','userId','roleId'],
  mounted() {
    // Set focus on the modal close button when the component is mounted
    this.$refs.closeIcon.focus();
  },
  methods: {
    async deleteRole() {
      try {
        await axios.delete(`/users/${this.userId}/locationpermissions/${this.roleId}`);
        this.showSuccess('The role has been deleted.');
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';
        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = 'Something went wrong.';
        } else {
          apiMsg = `${error.response.data.message}`;
        }
          this.showError(apiMsg);
      }
        this.$emit('reloadAuthorizationPanel');
    },
    closeModal() {
      this.$emit('closeModal');
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    showSuccess(error) {
      this.showNotification('success', [error]);
    },
    trapFocus(event) {
      const modal = this.$refs.modal;
      const focusableElements = modal.querySelectorAll('button, input, a, select, textarea, [tabindex]:not([tabindex="-1"])');
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey) {
        // Shift + Tab pressed (move focus backward)
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          event.preventDefault();
        }
      } else {
        // Tab pressed (move focus forward)
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          event.preventDefault();
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
</style>
